export { default } from './Facebook.tsx'
